import { createContext, useContext } from 'react'

export const DeterministicDetailsMatchingContext = createContext(false)

export const useDeterministicDetailsMatchingContext = () => useContext(DeterministicDetailsMatchingContext)
